module.exports = __webpack_public_path__ + "static/media/logo_gest_amarillo.7b6ddc62.svg";